var exports = {
  "zr": "ScreenSharePickerModal.module__root___UzFCV1",
  "XV": "ScreenSharePickerModal.module__topBar___UzFCV1",
  "vR": "ScreenSharePickerModal.module__tabs___UzFCV1",
  "Gn": "ScreenSharePickerModal.module__tabLabel___UzFCV1",
  "Ll": "ScreenSharePickerModal.module__tabIcon___UzFCV1",
  "Qs": "ScreenSharePickerModal.module__content___UzFCV1",
  "Vg": "ScreenSharePickerModal.module__grid___UzFCV1",
  "Nr": "ScreenSharePickerModal.module__card___UzFCV1",
  "e5": "ScreenSharePickerModal.module__cardPending___UzFCV1",
  "VH": "ScreenSharePickerModal.module__preview___UzFCV1",
  "np": "ScreenSharePickerModal.module__previewDevice___UzFCV1",
  "Gh": "ScreenSharePickerModal.module__cardSelected___UzFCV1",
  "oz": "ScreenSharePickerModal.module__previewImage___UzFCV1",
  "yQ": "ScreenSharePickerModal.module__devicePreviewVideo___UzFCV1",
  "A3": "ScreenSharePickerModal.module__previewPlaceholder___UzFCV1",
  "Cd": "ScreenSharePickerModal.module__devicePreviewPlaceholder___UzFCV1",
  "mP": "ScreenSharePickerModal.module__previewIcon___UzFCV1",
  "rP": "ScreenSharePickerModal.module__previewOverlay___UzFCV1",
  "H5": "ScreenSharePickerModal.module__previewAction___UzFCV1",
  "zI": "ScreenSharePickerModal.module__cardBody___UzFCV1",
  "Dm": "ScreenSharePickerModal.module__cardSourceIcon___UzFCV1",
  "gL": "ScreenSharePickerModal.module__cardSourceIconImage___UzFCV1",
  "JJ": "ScreenSharePickerModal.module__cardTitle___UzFCV1",
  "wk": "ScreenSharePickerModal.module__state___UzFCV1",
  "Ml": "ScreenSharePickerModal.module__loadingState___UzFCV1",
  "hZ": "ScreenSharePickerModal.module__stateIcon___UzFCV1",
  "CY": "ScreenSharePickerModal.module__stateHeading___UzFCV1",
  "_A": "ScreenSharePickerModal.module__stateTitle___UzFCV1",
  "tM": "ScreenSharePickerModal.module__stateActions___UzFCV1",
  "xj": "ScreenSharePickerModal.module__osNotice___UzFCV1",
  "Hr": "ScreenSharePickerModal.module__downloadCta___UzFCV1",
  "wN": "ScreenSharePickerModal.module__downloadCopy___UzFCV1",
  "z5": "ScreenSharePickerModal.module__downloadTitle___UzFCV1",
  "h": "ScreenSharePickerModal.module__downloadDescription___UzFCV1",
  "qm": "ScreenSharePickerModal.module__downloadActions___UzFCV1",
  "aQ": "ScreenSharePickerModal.module__platformIcons___UzFCV1",
  "tV": "ScreenSharePickerModal.module__platformIcon___UzFCV1",
  "qr": "ScreenSharePickerModal.module__footer___UzFCV1",
  "wu": "ScreenSharePickerModal.module__footerStart___UzFCV1",
  "vM": "ScreenSharePickerModal.module__streamSummary___UzFCV1",
  "ru": "ScreenSharePickerModal.module__streamSummaryTitle___UzFCV1",
  "$o": "ScreenSharePickerModal.module__streamSummaryDetails___UzFCV1",
  "sw": "ScreenSharePickerModal.module__streamSummaryDetail___UzFCV1",
  "Xd": "ScreenSharePickerModal.module__streamButton___UzFCV1",
  "ZF": "ScreenSharePickerModal.module__previewNotice___UzFCV1",
  "cP": "ScreenSharePickerModal.module__previewNoticeText___UzFCV1",
  "vw": "ScreenSharePickerModal.module__previewNoticeInfoButton___UzFCV1",
  "Ip": "ScreenSharePickerModal.module__previewInfoContent___UzFCV1",
  "Jh": "ScreenSharePickerModal.module__previewInfoParagraph___UzFCV1",
  "NZ": "ScreenSharePickerModal.module__previewInfoSwitch___UzFCV1",
};

module.exports = exports;
